import dropRepeats from 'xstream/extra/dropRepeats'
import xs from 'xstream'

export function intent ({Time, DOM}) {
  const {period$, autoplay$} = params(DOM)
  const prev$ = xs.empty()
  const goto$ = xs.of(0)
  const next$ = xs.combine(
    goto$,
    period$,
    autoplay$.compose(dropRepeats()),
  )
    .map(([, period, autoplay]) =>
      autoplay
        ? Time.periodic(period)
        : xs.empty()
    )
    .flatten()

  return {
    prev$,
    next$,
    goto$,
  }
}

export default intent

function params (DOMElement) {
  const params$ = DOMElement.element()
    .map(x => x.getAttribute('data-slider'))
    .map(x => x ? (JSON.parse(x) || {}) : {})

  return {
    period$: params$.map(x => parseFloat(x.period))
      .map(x => x || 4000), // default to 4s if x is not a number
    autoplay$: params$.map(x => x.autoplay)
      .map(x => x == undefined ? true : x), // default to true if not defined
  }
}



// WEBPACK FOOTER //
// ./slider/intent.js